import api from '@/api/reports';

const actions = {
  FETCH_GROUP_CLASSES_REPORT: async ({ commit, dispatch, state, rootGetters }) => {
    const { organizationId } = rootGetters;
    const {
      dateRange: { start: startDate, end: endDate },
      pageSize,
      currentPage,
      ordering,
      filters: { query: search },
    } = state;
    const offset = currentPage * pageSize;

    const params = {
      organization_id: organizationId,
      limit: pageSize,
      offset,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
    };

    dispatch('wait/start', 'groupClassesReport.fetching', { root: true });

    try {
      const { count, results: report } = await api.fetchGroupClassesReport(params);

      commit('SET_GROUP_CLASSES_REPORT', report);
      commit('SET_COUNT', count);

      return report;
    } finally {
      dispatch('wait/end', 'groupClassesReport.fetching', { root: true });
    }
  },

  DOWNLOAD_GROUP_CLASSES_REPORT: async ({ state, rootGetters }, { formatType }) => {
    const { organizationId } = rootGetters;
    const {
      dateRange: { start: startDate, end: endDate },
      pageSize,
      currentPage,
      ordering,
      filters: { query: search },
    } = state;
    const offset = currentPage * pageSize;
    const fields = state.columns.filter(x => x.showColumn).map(x => x.source_field);

    const params = {
      organization_id: organizationId,
      limit: pageSize,
      offset,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
    };

    await api.fetchGroupClassesReport({
      ...params,
      format: formatType,
      include: fields,
    });
  },

  FILTER_RESULTS: ({ commit, dispatch }, query) => {
    commit('SET_SEARCH_QUERY', query);
    dispatch('FETCH_GROUP_CLASSES_REPORT');
  },

  CHANGE_PAGE_SIZE: ({ commit, dispatch }, pageSize) => {
    commit('SET_PAGE_SIZE', pageSize);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_GROUP_CLASSES_REPORT');
  },

  CHANGE_CURRENT_PAGE: ({ commit, dispatch }, { currentPage }) => {
    commit('SET_CURRENT_PAGE', currentPage);
    dispatch('FETCH_GROUP_CLASSES_REPORT');
  },

  CHANGE_ORDERING: ({ commit, dispatch, state }, ordering) => {
    if (ordering === state.ordering) {
      return;
    }

    commit('SET_ORDERING', ordering);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_GROUP_CLASSES_REPORT');
  },

  DATE_RANGE_UPDATE: ({ commit, dispatch }, dateRange) => {
    commit('SET_DATE_RANGE', dateRange);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_GROUP_CLASSES_REPORT');
  },
};

export default actions;
